import { render, staticRenderFns } from "./CardapioExemplo.vue?vue&type=template&id=09eb084a&scoped=true&"
import script from "./CardapioExemplo.vue?vue&type=script&lang=js&"
export * from "./CardapioExemplo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb084a",
  null
  
)

export default component.exports